import Honeybadger from '@honeybadger-io/js';

export default class DebugManager {

  static initHoneybadger() {
    if (FPD.errorReporting) {
      Honeybadger.configure({
        apiKey: process.env.HONEYBADGER_PROJECT_ID,
        environment: process.env.JS_ENV,
        enableUncaught: true,
        enableUnhandledRejection: true
      })

      Honeybadger.setContext({
        shopify_domain: Shopify.shop
      })
    }
  }

  static verifyLineItemProperties() {
    if (FPD.errorReporting) {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          cart.items.forEach(item => {
            if (!item.properties || !item.properties['_fpd-hash']) {
              Honeybadger.notifyAsync("not customized line item", {
                title: item.title,
                product_id: item.product_id,
                variant_id: item.variant_id,
                properties: item.properties
              })
            }
          })
        })
    }
  }

  static reportError(error) {
    if (FPD.errorReporting) {
      Honeybadger.notifyAsync(error)
    }
  }
}